import { hasAllPurposesConsent } from "@escapio/shared/tracker/ConsentObserver";
import { hasTracking } from "@escapio/shared/state/client-settings";

customElements.define(
	"esc-pinterest-loader",
	class extends HTMLElement {
		async connectedCallback() {
			if (!hasTracking) return;
			await hasAllPurposesConsent;
			this.load();
		}

		load() {
			!(function (e) {
				if (!window.pintrk) {
					window.pintrk = function () {
						window.pintrk.queue.push(Array.prototype.slice.call(arguments));
					};
					var n = window.pintrk;
					((n.queue = []), (n.version = "3.0"));
					var t = document.createElement("script");
					((t.async = !0), (t.src = e));
					var r = document.getElementsByTagName("script")[0];
					r.parentNode.insertBefore(t, r);
				}
			})("https://s.pinimg.com/ct/core.js");
			window.pintrk("load", "2613985584035");
			window.pintrk("page");
		}
	},
);
